import React from 'react';
import ForgotPassword from '../components/ForgotPassword';
import LoginFooter from '../components/LoginFooter';
import Header from '../components/HeaderLogin';


const ForgotPasswordPage = () => {
  return (
    <div className="mainFrame" style = {{minHeight: '100vh'}}>
      <Header/>
      <ForgotPassword/>
      <LoginFooter/>
    </div>
  );
};

export default ForgotPasswordPage;
